/**
 * Cleans the provided RFID string
 *
 * @param rfid - The RFID string to be cleaned.
 * @returns A cleaned version of the RFID or a default string if the provided RFID is falsy.
 */
export const cleanRfid = (rfid: string): string => {
  if (!rfid) {
    console.error('NO RFID');
  }

  // Save original RFID in case of failure
  const originalRFID = rfid;

  let cleanedRFID = originalRFID.replace(/\s+/g, '');

  const enterIndex = cleanedRFID.indexOf('Enter');

  // Find the first occurrence of any of the patterns
  const firstOccurrence = Math.min(enterIndex !== -1 ? enterIndex : Infinity);

  // If any of the patterns is found, take the string value before it
  if (firstOccurrence !== Infinity) {
    cleanedRFID = cleanedRFID.substring(0, firstOccurrence);
  } else {
    return cleanedRFID;
  }

  try {
    return cleanedRFID;
  } catch (e) {
    console.error('Error in cleanRFID function: ', e);
    return originalRFID;
  }
};
